import * as types from "../constants/actionTypes";


export const errorInitialState = {
};

export default function errorReducer(state = errorInitialState, action) {
    switch (action.type) {
        case types.APPLICATION_ERROR:
            return { ...state, componentErrors: [...state.componentErrors, action.error] };
        default:
            return { ...state };


    }
}
